import SpriteSymbol from "../../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "bar-chart-2",
  "use": "bar-chart-2-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 24 24\" id=\"bar-chart-2\">\n<path d=\"M18,21c-0.6,0-1-0.4-1-1V10c0-0.6,0.4-1,1-1s1,0.4,1,1v10C19,20.6,18.6,21,18,21z\" />\n<path d=\"M12,21c-0.6,0-1-0.4-1-1V4c0-0.6,0.4-1,1-1s1,0.4,1,1v16C13,20.6,12.6,21,12,21z\" />\n<path d=\"M6,21c-0.6,0-1-0.4-1-1v-6c0-0.6,0.4-1,1-1s1,0.4,1,1v6C7,20.6,6.6,21,6,21z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol